const LOGIN_HOME = '/login';

export const LOGIN_ROUTES = {
  index: LOGIN_HOME,
};
